import * as React from "react";

function Chevron(props) {
    return (
        <svg width={11} height={7} {...props}>
            <path
                fill="none"
                stroke="#1D1D1D"
                d="M.833 1.167L5.5 5.834l4.667-4.667"
            />
        </svg>
    );
}

export default Chevron;
